import {BrowserRouter} from 'react-router-dom';

import {AppRouterWrapper} from './AppRouterWrapper';

export const App = () => {
  return (
    <BrowserRouter>
      <AppRouterWrapper />
    </BrowserRouter>
  );
};
